<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.appAbout') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{ $ml.get('shared.settings') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.appAbout') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4 text-center">
          <div class="box box-primary">
            <div class="box-header">
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body" style="height:200px;">
              <h3>{{ $store.getters.getCompanyName }}</h3>
              <a style="color:#000000;font-size:18px;" :href="$store.getters.getCompanyURL" target="_blank">{{
                $store.getters.getCompanyURL.replace("https://", "").replace("https://", "") }}</a>
              <h4>
                <strong>{{ $ml.get('shared.version') }}</strong>
                : {{ version }}
              </h4>
            </div>
          </div>
          <hr />
          <!--<h4>
            <strong>{{$ml.get('shared.manufacturerInformation')}}</strong>
          </h4>
          <hr />
          <div class="text-center" style="font-size:50px;">&</div>
          <h3>
            <strong>Tamdabu Yazılım</strong>
          </h3>
          <h4>
            <i class="fa fa-globe"></i>
            <a href="http://www.tamdabuyazilim.com" target="_blank">tamdabuyazilim.com</a>
          </h4>
          <h4>
            <i class="fa fa-envelope"></i>
            <a href="mailto:info@tamdabuyazilim.com">info@tamdabuyazilim.com</a>
          </h4>
          <h4>
            <i class="fa fa-phone fa-flip-horizontal"></i> 0212 232 01 69
          </h4>-->
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">Sürüm Notları</h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body" :style="windowHeightSize">
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.49
              </h4>
              <ul>
                <li><strong>Demirbaş Modülü</strong>ne fotoğraf, belge ekleme, kategoriler, depolar, özellikler ve belge tanımları gibi yeni özellikler eklendi.</li>
                <li>Tanımlamalar menüsüne <strong>Belge Tanımları</strong> sayfası eklendi.</li>
                <li>Kişiler sayfasına <strong>zimmetler</strong> sekmesi eklendi.</li>
                <li>Kişiler sayfasına <strong>belgeler</strong> sekmesi eklendi.</li>
                <li>Kişiler sayfasındaki belge yükleme alanına İSG evrakları ve geçerlilik tarihi kontrolü özelliği geliştirildi.</li>
                <li>Giriş çıkış raporlarına <strong>görev yeri</strong> alanı eklendi.</li>
                <li>Toplu işlemler sayfasında kişilere <strong>toplu geçerlilik başlangıç ve bitiş tarihi girme</strong> özelliği geliştirildi.</li>
                <li>Toplu işlemler sayfasına <strong>toplu görev yeri</strong> tanımlama özelliği eklendi.</li>
                <li>Kişi bilgileri raporuna <strong>geçerlilik tarihi</strong> alanları eklendi.</li>
                <li>Kontrol panelinde terminal durumları listesi, istatistik widgetı olarak değiştirildi. Üstüne tıklandığında terminal durumları raporu açılacak şekilde geliştirildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.48
              </h4>
              <ul>
                <li><strong>Demirbaş Modülü</strong> geliştirildi.</li>
                <li>Kişiler sayfasına <strong>maaş</strong> sekmesi eklendi.</li>
                <li>Kişiler sayfasına <strong>başlangıç geçerlilik tarihi</strong> ve <strong>bitiş geçerlilik tarihi</strong> eklendi.</li>
                <li>Tanımlamalar menüsüne <strong>Görev Yeri Tanımları</strong> sayfası eklendi.</li>
                <li>Kişiler sayfasına <strong>Görev Yerleri</strong> sekmesi eklendi.</li>
                <li>Şirket ayarlarına <strong>Zorunlu Alanlar</strong> sekmesi eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.47
              </h4>
              <ul>
                <li><strong>Vardiya Raporu</strong> eklendi.</li>
                <li><strong>Dikey İlk Giriş Son Çıkış Raporu</strong> eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.46
              </h4>
              <ul>
                <li>Ziyaretçi takip ekranına gelinen departman bilgisi eklendi.</li>
                <li>Ziyaretçi takip raporlarına "Departman Bazlı Ziyaretçi Raporu" eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.45
              </h4>
              <ul>
                <li>Otomatik mail ayar sayfası iyileştirildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.44
              </h4>
              <ul>
                <li>Ziyaretçi takip ekranındaki personel sorgulama ekranı iyileştirildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.43
              </h4>
              <ul>
                <li>Kontrol panelindeki raporlara arama özelliği eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.42
              </h4>
              <ul>
                <li>Kontrol paneline aktif mobil kullanıcılar widget'ı eklendi.</li>
                <li>Kontrol panelinde bulunan içeridekiler/dışarıdakiler raporlarına okuyucu adı sütunu eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.41
              </h4>
              <ul>
                <li>Toplu işlemler sayfasına toplu geçiş grubu güncelleme özelliği eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.40
              </h4>
              <ul>
                <li>Tema dosyalarında güncelleme yapıldı.</li>
                <li>Kontrol paneline geç gelenler widget'ı eklendi.</li>
                <li>Terminaller sayfasındaki okuyucu bilgilerine <strong>ana kapı</strong> seçimi eklendi. Bu seçim kontrol panelinde yer alan içeridekiler/dışarıdakiler widget'larını etkileyecektir.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.39
              </h4>
              <ul>
                <li>Otomatik mail ayarlarına yeni rapor eklendi.</li>
                <li>Tema dosyalarında güncelleme yapıldı.</li>
                <li>Login tasarımı değiştirildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.38
              </h4>
              <ul>
                <li>Puantaj Yönetimi sayfasında iyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.37
              </h4>
              <ul>
                <li>Toplu İşlemler sayfasına Yemekhane işlemleri eklendi.</li>
                <li>Kontrol panelinde ufak görsel düzenlemeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.36
              </h4>
              <ul>
                <li>Puantaj Yönetimi sayfası iyileştirildi.</li>
                <li>Terminaller sayfasındaki Seri No alanı tüm markalar için aktif hale getirildi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.35
              </h4>
              <ul>
                <li>Puantaj Yönetimi sayfası yenilendi.</li>
                <li>Uygulamanın fontu değiştirildi.</li>
                <li>Kontrol panelinde bulunan izin taleplerindeki görsel sorunu düzeltildi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.34
              </h4>
              <ul>
                <li>Devriye Tur Kontrol modülü için görevli sayfasına eşleştirme kaldırma özelliği eklendi.</li>
                <li>Devriye Tur Kontrol modülü için görevli sayfasına telefon eşleştirme ve hesap kontrolü özelliği
                  eklendi. Eşleştirme kaldırma özelliği eklendi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.33
              </h4>
              <ul>
                <li>Devriye Tur Kontrol modülü için kullanıcı yetkileri eklendi.</li>
                <li>Devriye Tur Kontrol modülüne <strong>Tur Hareket Raporu</strong> eklendi.</li>
                <li>Devriye Tur Kontrol modülüne <strong>Tur Olay Raporu</strong> eklendi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.32
              </h4>
              <ul>
                <li>Devriye Tur Kontrol modülü için görevlilere sorumlu kullanıcı alanları eklendi.</li>
                <li>Devriye Tur Kontrol modülü için tur tanımlarına saat kontrolü eklendi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.31
              </h4>
              <ul>
                <li>Devriye Tur Kontrol modülüne kontrol noktaları için koordinat alanları eklendi.</li>
                <li>Devriye Tur Kontrol modülüne kontrol noktaları ekranı tasarımı iyileştirildi.</li>
                <li>Devriye Tur Kontrol modülüne kontrol noktaları ekranı tasarımı iyileştirildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.30
              </h4>
              <ul>
                <li>Terminal okuyucularına koordinat alanları eklendi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.29
              </h4>
              <ul>
                <li>Bazı hatalar giderildi.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.28
              </h4>
              <ul>
                <li>Devriye Tur Kontrol modülü yenilendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.27
              </h4>
              <ul>
                <li>Yeni rapor eklendi: <strong>Detaylı Ziyaretçi Hareket Raporu</strong>.</li>
                <li>İyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.26
              </h4>
              <ul>
                <li>Vardiya Shift Takvimi modülü üzerinde yeni geliştirmeler yapıldı.</li>
                <li>İlk Giriş Son Çıkış Raporunda iyileştirmeler yapıldı.</li>
                <li>Kart tasarım şablonları sayfası güncellendi.</li>
                <li>Çift taraflı kart baskısı özelliği eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.25
              </h4>
              <ul>
                <li>Vardiya Shift Takvimi modülü üzerinde geliştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.24
              </h4>
              <ul>
                <li>Kullanıcı yetki grupları geliştirildi.</li>
                <li>Vardiya Shift Takvimi modülü geliştirildi.</li>
                <li>Bakiyeli satış modülünde ek geliştirmeler yapıldı.</li>
                <li>Güvenlik iyileştirmeleri yapıldı.</li>
                <li>Küçük hatalar giderildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.23
              </h4>
              <ul>
                <li>Gerçekleşen hareketler takvimi eklendi.</li>
                <li>Hafta tatili takvimi eklendi.</li>
                <li>Vardiya Shift Takvimi modülü geliştirildi.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
                <li>Kontrol panelinde geliştirmeler yapıldı. İstatistiklere grafikler eklendi.</li>
                <li>Küçük hatalar giderildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.22
              </h4>
              <ul>
                <li>Yurt takip sistemi hızlandırıldı. Hatalar giderildi.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
                <li>Küçük hatalar giderildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.21
              </h4>
              <ul>
                <li>Küçük hatalar giderildi.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.20
              </h4>
              <ul>
                <li>Esnek kart tasarımları için Kart Tasarım Şablonları ekranı hazırlandı.</li>
                <li>Kişiler üzerinde istenilen şablon üzerinden kart basma özelliği geliştirildi.</li>
                <li>Kontrol paneli üzerinde geliştirmeler yapıldı.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.19
              </h4>
              <ul>
                <li>Bakiye düşme ekranı geliştirildi.</li>
                <li>Logo ve görseller üzerinde değişiklikler yapıldı.</li>
                <li>Yazı font tipi değiştirildi.</li>
                <li>Görsel arayüz üzerinde geliştirmeler yapıldı.</li>
                <li>Mixa Enroll Mobil uygulaması geliştirildi. Mobil uygulama ile entegrasyon geliştirmeleri yapıldı.
                </li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
                <li>Küçük hatalar giderildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.18
              </h4>
              <ul>
                <li>Puantaj Yönetimi ekranı eklendi.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
                <li>Terminal işlemleri ekranında değişiklikler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.17
              </h4>
              <ul>
                <li>Kontrol paneli istatistiklerinde iyileştirmeler yapıldı.</li>
                <li>Profilim alanı eklendi.</li>
                <li>Kullanıcılar bölümüne Aktif Mi özelliği eklendi.</li>
                <li>Bazı güvenlik iyileştirmeleri yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.16
              </h4>
              <ul>
                <li>Hızlandırmalar ve iyileştirmeler yapıldı.</li>
                <li>Yeni puantaj raporları eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.15
              </h4>
              <ul>
                <li>Puantaj hesaplamalarında geliştirmeler yapıldı.</li>
                <li>Terminal okuyucularına kapı adı alanı eklendi.</li>
                <li>Kapı açık/kapalı bilgisini görüntülemek için canlı izleme sayfasına kapı durumları alanı eklendi.
                </li>
                <li>Esnek senaryoları desteklemek için senaryolar alt yapısı oluşturuldu. Zaman bazlı alarm çaldırabilme
                  komutları eklendi.</li>
                <li>Yurt takip modülünde bölgeler sayfası iyileştirildi.</li>
                <li>Kişiler sayfasına timezone alanı eklendi.</li>
                <li>Devriye tur kontrol modülü geliştirildi.</li>
                <li>Kişi listelerine sicil numarası alanı eklendi.</li>
                <li>Kişi listelerine sıralama özelliği eklendi.</li>
                <li>Hızlandırmalar ve iyileştirmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.14
              </h4>
              <ul>
                <li>Hızlandırmalar ve iyileştirmeler yapıldı.</li>
                <li>Kontrol panelinde bulunan istatistik alanları üzerinde düzeltmeler yapıldı.</li>
                <li>Bazı raporlarda hızlandırma işlemleri yapıldı.</li>
                <li>Katı filtre özelliğindeki sorun düzeltildi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.13
              </h4>
              <ul>
                <li>Hızlandırmalar ve iyileştirmeler yapıldı.</li>
                <li>Bazı raporlarda hızlandırma işlemleri yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.12
              </h4>
              <ul>
                <li>Arayüzde iyileştirmeler yapıldı.</li>
                <li>Yazılımın arkaplanında iyileştirmeler yapıldı.</li>
                <li>Kullanıcı yetkilendirmelerinde yetki grupları güçlendirildi. Yazılım üzerinde tüm sayfalar
                  kullanıcının yetkisi olduğu departman, geçiş grubu, yemek grubu, çalışma grubu, statü ve durumu
                  alanlarına göre filtrelenip veriler getirilir hale gelmiştir. Yani yetkisiz departmanlar listelerde
                  gözükmeyecektir. Buna kontrol panelindeki istatistikler de dahil.</li>
                <li>Kullanıcılar sayfasındaki yetkili departmanlar alanı Kullanıcı Yetkileri sayfasına taşındı ve daha
                  detaylı hale getirildi.</li>
                <li>Yeni raporlar eklendi.</li>
                <li>Otomatik mail özelliği eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.11
              </h4>
              <ul>
                <li>İşlem kayıtlarında kullanıcı bazlı kayıtları görme sorunu düzeltildi.</li>
                <li>İki tarih arasındaki izin kayıtlarını toplu silme özelliği getirildi.</li>
                <li>Sil butonu İşten çıkış bildir butonu altına taşındı.</li>
                <li>Yeni raporlar eklendi.</li>
                <li>Kullanıcı bazlı varsayılan filtre yetki grubu özelliği eklendi. Kullanıcıların varsayılan filtresine
                  göre kişiler otomatik listenecektir. Detaylı filtre kullanılmak istenirse yeniden filtreleme
                  yapılabilecektir.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.10
              </h4>
              <ul>
                <li>Her sayfaya arama özelliği eklendi.</li>
                <li>Yeni raporlar eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.9
              </h4>
              <ul>
                <li>SMS modülü eklendi.</li>
                <li>Öğrenciler için özel ekranlar oluşturuldu.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.8
              </h4>
              <ul>
                <li>Arayüzde iyileştirmeler yapıldı.</li>
                <li>Plaka tanıma modülü eklendi.</li>
                <li>Araç takibi için kontrol paneli istatistik alanları oluşturuldu.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.7
              </h4>
              <ul>
                <li>İyileştirmeler yapıldı.</li>
                <li>Yeni raporlar eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.6
              </h4>
              <ul>
                <li>Arayüzde değişiklikler ve iyileştirmeler yapıldı.</li>
                <li>Geçerlilik tarihi özelliği ve üye takip modülü eklendi.</li>
                <li>Bazı raporlarda düzeltmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.5
              </h4>
              <ul>
                <li>Yeni marka terminaller ile haberleşme entegrasyonları oluşturuldu.</li>
                <li>Parmak izi alma ile ilgili arayüzde yeni ekranlar oluşturuldu.</li>
                <li>Bazı raporlarda düzeltmeler yapıldı.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.4
              </h4>
              <ul>
                <li>İyileştirmeler yapıldı.</li>
                <li>Bazı kritik hatalar tespit edildi ve giderildi.</li>
                <li>Yeni raporlar eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.3
              </h4>
              <ul>
                <li>İyileştirmeler yapıldı.</li>
                <li>Yemekhane takip modülü oluşturuldu.</li>
                <li>Kontrol panelindeki istatistiklere tıklandığında açılan hızlı rapor özelliği eklendi.</li>
                <li>Yeni raporlar eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.2
              </h4>
              <ul>
                <li>İyileştirmeler yapıldı.</li>
                <li>Bazı hatalar giderildi.</li>
                <li>Yeni marka terminaller ile haberleşme entegrasyonları oluşturuldu.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.1
              </h4>
              <ul>
                <li>Ziyaretçi takip modülü oluşturuldu.</li>
                <li>İngilizce dil seçeneği ve renk tema seçeneği eklendi.</li>
              </ul>
              <hr />
              <h4>
                <i class="fa fa-arrow-right"></i> 1.0.0
              </h4>
              <ul>
                <li>Kararlı sürüm tamamlandı.</li>
              </ul>
            </div>
          </div>
          <!--box end-->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      version: this.$store.state.version,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 240;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/appAbout/AppAbout.vue